import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";

import { useCustomTinyMceCssContent } from "../hooks/data/useCustomTinyMceCssContent";
import { GlobalApplicationState } from "globalApplicationState";

interface ICustomCssProps {
    enabled: boolean;
}

/**
 * Renders link tag for tenant custom css file
 */
export const CustomCss: React.FunctionComponent<ICustomCssProps> = ({
    enabled,
}) => {
    const { tenantSettings } = useSelector((state: GlobalApplicationState) => state.settings);
    const { tenantId } = tenantSettings;
    const { tenant: requestTenantId } = useParams<{ tenant: string }>();
    const { location: { pathname } } = useHistory();

    // try use logged in user, fallback to request tenant id in order to support custom css on public pages
    const tenantIdToUse = tenantId || requestTenantId;
    const { customCss } = useCustomTinyMceCssContent({ enabled: enabled || pathname.includes("/public/"), tenantId: tenantIdToUse });

    return (
        <>
            {customCss?.sasUrl &&
                <link rel="stylesheet" type="text/css" href={customCss.sasUrl} />}
        </>
    );
}
